import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const Footer = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <footer className="bg-gray-900 text-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4">
          <p className="text-sm md:text-base leading-relaxed text-gray-300">
            <a 
              href="/Regulamin_uslugi_dostepowej.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white hover:text-red-400 underline transition-colors duration-200"
            >
              {t.footer.terms}
            </a>
          </p>
          <p className="text-sm md:text-base leading-relaxed text-gray-300">
            {t.footer.adult}
          </p>
          <p className="text-sm md:text-base leading-relaxed text-gray-300">
            {t.footer.organizer}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
